import logo from "../../assets/images/logo1.png";
import carouselImg1 from "../../assets/images/registerCarouselImg1.png";
import { ErrorMessage, Formik } from "formik";
import CustomSvg from "../svgs/CustomSvg";
import { useEffect, useState } from "react";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { FaPhone } from "react-icons/fa6";
import { Carousel, Spinner } from "react-bootstrap";
import SuccessModal from "./auxiliary/SuccessModal";
import { register, SendEmailOTP } from "../apiRequests/requestApi";
import InputMask from "react-input-mask";
import { useUser } from "../../utils/hooks";
import CustomErrorMsg from "../errorMsg/CustomErrorMsg";
import * as yup from "yup";
import {
  MdOutlineCheckBox,
  MdOutlineCheckBoxOutlineBlank,
} from "react-icons/md";
import { EMAIL_REGEX, ONLY_NUMBERS_REGEX } from "../helpers/regex";
import ScrollTo from "../scroll/ScrollTo";

import { registerCeleb } from "../apiRequests/requestApiCeleb";
import EyeToggleIcon from "../../assets/svg/eyeToggle";
import { FaLink } from "react-icons/fa";
import { FaGift } from "react-icons/fa"; // <-- Add this import

const carouselItems = [
  {
    img: carouselImg1,
    caption:
      "Play classics like Scrabble, WHOT, Chess, and Snooker with friends and family while betting to win big.",
  },
];

export default function Register({ navigateTo, accountType }) {
  const goToVerifyEmail = () => navigateTo("/email-verification");
  const goToLogin = () => navigateTo("/login");
  const goToTerms = () => navigateTo("/terms");

  const { setUserDetails, user } = useUser();

  const validationSchema = yup.object().shape({
    email: yup
      .string()
      .required("Email required")
      .matches(EMAIL_REGEX, "Must be a valid email address"),
    phoneNumber: yup
      .string()
      .required("Phone number required"),
    password: yup.string().required("Password required"),
    confirmPassword: yup
      .string()
      .required("Confirm password required")
      .oneOf([yup.ref("password"), null], "Passwords must match"),
  });

  const [referralCode, setRefferalCode] = useState(null);
  const [termsAgreed, setTermsAgreed] = useState(false);
  const [apiReqs, setApiReqs] = useState({
    isLoading: false,
    data: null,
    errorMsg: null,
  });
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
  const [successModal, setSuccessModal] = useState({
    visible: false,
    onHide: null,
    size: "md",
  });

  // const themeClass = accountType === 'celebrity' ? 'register-bg-celebrity' : 'register-bg-regular';

  useEffect(() => {
    if (apiReqs.data && apiReqs.isLoading) {
      const { data } = apiReqs;
      submit({ requestBody: data });
    }
  }, [apiReqs]);

  const submit = async ({ requestBody }) => {
    try {
      const { dob, email, confirmPassword, ...rest } = requestBody;

      const formattedDate = new Date(dob).toLocaleDateString("en-US");

      const details = {
        ...rest,
        email,
        dob: formattedDate,
        // referralCode,
      };

      const celebDetails =
        accountType === "celebrity"
          ? {
              ...rest,
              email,
            }
          : details;

      const response = await (accountType === "celebrity"
        ? registerCeleb(celebDetails)
        : register(details));

      const tokens = { ...response.data };
      localStorage.setItem("token", tokens);
      setUserDetails({
        ...user,
        email,
      });
      openSuccessModal();

      const otpResponse = await SendEmailOTP(email);

      return setApiReqs({ isLoading: false, data: null, errorMsg: null });
    } catch (error) {
      setApiReqs({
        isLoading: false,
        data: null,
        errorMsg: error && error.message ? error.message : "Unexpected Error",
      });
    }
  };

  const togglePasswordVisibility = () => setPasswordVisible((prev) => !prev);
  const toggleConfirmPasswordVisibility = () =>
    setConfirmPasswordVisible((prev) => !prev);

  const openSuccessModal = () =>
    setSuccessModal({ visible: true, onHide: hideSuccessModal, size: "md" });
  const hideSuccessModal = () =>
    setSuccessModal({ visible: false, onHide: null, size: "md" });

  const toggleTermsAgreement = () => setTermsAgreed((prev) => !prev);

  const displayCarouselItems = carouselItems.map((item, i) => {
    const { img, caption } = item;

    return (
      <div
        key={i}
        className="d-flex align-items-center justify-content-center flex-column py-5"
      >
        <div className="col-lg-6 d-flex align-items-center justify-content-center mb-5">
          <img src={img} className="col-lg-12" alt="" />
        </div>

        <p className="small-txt txt-F7FAFF font-weight-400 line-height-30 m-0 p-0 font-family-poppins text-center">
          {caption}
        </p>
      </div>
    );
  });

  return (
    <div className="min-h-screen py-5 bg-[#130828]">
      {accountType === "celebrity" ? (
        <ScrollTo condition={apiReqs.errorMsg}>
          <div className="login-bg-celebrity overflow-y-none py-2 md:py-4 px-3 md:px-5">
            <div className="w-full max-w-md h-2 bg-gray-200 rounded mb-6">
              <div className="h-full w-2/3 bg-[#56920D] rounded" />
            </div>
            {/* <div className="flex flex-col items-start mb-2">
              <div className="flex flex-col items-center justify-center">
                <div className="mb-0 flex items-center justify-center w-full max-w-lg">
                  <img src={logo} className="w-full" alt="Logo" />
                </div>
              </div>
            </div> */}
            <div className="flex flex-col md:flex-row justify-between items-center">
              <div className="md:w-1/2 w-full">
                <h1 className="text-4xl text-center font-semibold mb-4 font-quantico bg-gradient-to-r from-[#56920D] to-[#B7D080] text-transparent bg-clip-text">
                  Create an account
                </h1>
                <p className="text-sm  text-center text-white/70 font-light font-poppins mb-4">
                  Please complete your profile
                </p>

                {apiReqs.errorMsg && (
                  <CustomErrorMsg errorMsg={apiReqs.errorMsg} />
                )}

                <Formik
                  validationSchema={validationSchema}
                  initialValues={{
                    email: "",
                    socialMediaPlatform: "",
                    socialMediaHandle: "",
                    password: "",
                    confirmPassword: "",
                    phoneNumber: "",
                  }}
                  onSubmit={(values) => {
                    if (!termsAgreed) {
                      return setApiReqs({
                        isLoading: false,
                        errorMsg:
                          "Agree to the terms and conditions to proceed",
                        data: null,
                      });
                    }
                    setApiReqs({
                      isLoading: true,
                      errorMsg: null,
                      data: values,
                    });
                  }}
                >
                  {({
                    isValid,
                    dirty,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    values,
                  }) => (
                    <>
                      <div className="mb-4">
                        <div className="flex items-center gap-2 bg-white/10 rounded-xl p-2">
                          <div className="w-6">
                            <CustomSvg name="profile" color="#fff" />
                          </div>
                          <input
                            type="text"
                            name="socialMediaHandle"
                            placeholder="Enter your social media handle"
                            value={values.socialMediaHandle}
                            onChange={handleChange}
                            className="w-full bg-transparent text-white text-base font-quantico outline-none"
                          />
                        </div>
                        <ErrorMessage
                          name="socialMediaHandle"
                          component={CustomErrorMsg}
                        />
                      </div>
                      {["email", "phoneNumber"].map((field, index) => (
                        <div className="mb-4" key={field}>
                          <div className="flex items-center gap-2 bg-white/10 rounded-xl p-2">
                            <div className="w-6">
                              {field === "email" && <CustomSvg name="mail" />}
                              {field === "phoneNumber" && (
                                <FaPhone size={16} color="#fff" />
                              )}
                            </div>
                            <input
                              type={
                                field === "email"
                                  ? "email"
                                  : field === "phoneNumber"
                                  ? "text"
                                  : "text"
                              }
                              name={field}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values[field]}
                              placeholder={`Enter your ${field
                                .replace(/([A-Z])/g, " $1")
                                .toLowerCase()}`}
                              className="w-full bg-transparent text-white text-base font-quantico outline-none"
                            />
                          </div>
                        </div>
                      ))}

                      <div className="mb-4">
                        <div className="flex items-center gap-2 bg-white/10 rounded-xl p-2">
                          <div className="w-6">
                           <FaLink size={16} color="#fff" />
                          </div>
                          <select
                            name="socialMediaPlatform"
                            value={values.socialMediaPlatform}
                            onChange={handleChange}
                            className="w-full bg-transparent text-white text-base font-quantico outline-none"
                          >
                            <option value="" disabled>
                              Select a social media platform
                            </option>
                            <option className="bg-[#]" value="instagram">
                              Instagram
                            </option>
                            <option className="bg-gray-300" value="tiktok">
                              TikTok
                            </option>
                            <option className="bg-gray-300" value="youtube">
                              YouTube
                            </option>
                            <option className="bg-gray-300" value="x">
                              X (Twitter)
                            </option>
                            <option className="bg-gray-300" value="snapchat">
                              Snapchat
                            </option>
                            <option className="bg-gray-300" value="linkedin">
                              LinkedIn
                            </option>
                            <option className="bg-gray-300" value="facebook">
                              Facebook
                            </option>
                          </select>
                        </div>
                        <ErrorMessage
                          name="socialMediaPlatform"
                          component={CustomErrorMsg}
                        />
                      </div>

                      {["password", "confirmPassword"].map((field) => (
                        <div className="mb-4" key={field}>
                          <div className="flex items-center gap-2 bg-white/10 rounded-xl p-2">
                            <div className="w-6">
                              <CustomSvg name="lock" />
                            </div>
                            <input
                              type={
                                (field === "password" && passwordVisible) ||
                                (field === "confirmPassword" &&
                                  confirmPasswordVisible)
                                  ? "text"
                                  : "password"
                              }
                              name={field}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values[field]}
                              placeholder={`Enter your ${
                                field === "confirmPassword"
                                  ? "confirm password"
                                  : "password"
                              }`}
                              className="w-full bg-transparent text-white text-base font-quantico outline-none"
                            />
                            <div className="absolute right-6">
                              <EyeToggleIcon
                                visible={passwordVisible}
                                onClick={() =>
                                  setPasswordVisible(!passwordVisible)
                                }
                              />
                            </div>
                          </div>
                          <ErrorMessage
                            name={field}
                            component={CustomErrorMsg}
                          />
                        </div>
                      ))}

                      <div className="flex items-center mb-5">
                        <div
                          onClick={toggleTermsAgreement}
                          className="cursor-pointer"
                        >
                          {termsAgreed ? (
                            <MdOutlineCheckBox color="#FFF" size={15} />
                          ) : (
                            <MdOutlineCheckBoxOutlineBlank
                              color="#FFF"
                              size={15}
                            />
                          )}
                        </div>
                        <p className="text-white/70 text-sm ml-2 font-poppins">
                          By checking the box you agree to our{" "}
                          <span className="text-[#56920D]">Terms</span> and{" "}
                          <span className="text-[#56920D]">Conditions</span>.
                        </p>
                      </div>

                      <button
                        style={{
                          opacity:
                            !(isValid && dirty) || apiReqs.isLoading ? 0.5 : 1,
                        }}
                        onClick={handleSubmit}
                        disabled={!(isValid && dirty) || apiReqs.isLoading}
                        className="w-full bg-[#56920D] text-white py-2 rounded-xl flex items-center justify-center gap-2"
                      >
                        {apiReqs.isLoading ? (
                          <Spinner size="sm" variant="light" />
                        ) : (
                          <>
                            <span className="font-poppins font-medium">
                              Register
                            </span>
                            <CustomSvg name="arrow-right" />
                          </>
                        )}
                      </button>

                      <div
                        onClick={goToLogin}
                        className="text-center mt-4 text-sm text-white font-poppins cursor-pointer"
                      >
                        Already have an account?{" "}
                        <span className="text-[#56920D]">Login</span>.
                      </div>
                    </>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </ScrollTo>
      ) : (
        <ScrollTo condition={apiReqs.errorMsg}>
          <div className=" px-3 md:px-5 lg:px-5">
            <div className="w-full max-w-md h-2 bg-gray-200 mt-2 rounded mb-6">
              <div className="h-full w-2/3 bg-[#BE3593] rounded" />
            </div>
            {/* <div className="flex flex-col items-start mb-2">
              <div className="flex flex-col items-center justify-center">
                <div className="mb-0 flex items-center justify-center w-full max-w-lg">
                  <img src={logo} className="w-full" alt="Logo" />
                </div>
              </div>
            </div> */}


            <div className="flex flex-col lg:flex-row md:flex-row justify-between items-center">
              <div className="w-full text-center lg:w-5/12">
                <h1 className="m-0 p-0 text-2xl text-white font-medium mb-4 font-quantico">
              
                  <span className="bg-gradient-to-r from-[#BD3193] to-[#9FCB3A] text-transparent bg-clip-text">
                    Create an account
                  </span>
                </h1>
                <p className="m-0 p-0 text-sm text-white/70 font-poppins font-light mb-4">
                  New here! Create a new account
                </p>

                {apiReqs.errorMsg && (
                  <div className="mb-4">
                    <CustomErrorMsg errorMsg={apiReqs.errorMsg} />
                  </div>
                )}

                <Formik
                  validationSchema={validationSchema}
                  initialValues={{
                    username: "",
                    email: "",
                    dob: "",
                    password: "",
                    confirmPassword: "",
                    phoneNumber: "",
                    referralCode: "", // add referralCode to initial values
                  }}
                  onSubmit={(values) => {
                    const { username, email, dob, password, phoneNumber, referralCode } = values;

                    if (!termsAgreed) {
                      return setApiReqs({
                        isLoading: false,
                        data: null,
                        errorMsg:
                          "Agree to the terms and conditions to proceed",
                      });
                    }

                    return setApiReqs({
                      isLoading: true,
                      errorMsg: null,
                      data: referralCode
                        ? { username, email, dob, password, phoneNumber, referralCode }
                        : { username, email, dob, password, phoneNumber },
                    });
                  }}
                >
                  {({
                    isValid,
                    dirty,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    values,
                  }) => (
                    <>
                      <div className="mb-3 w-full space-y-4">
                        {/* Username */}
                        <div>
                          <div className="flex items-center justify-between rounded-2xl bg-white/10 p-2">
                            <div className="w-[3%]">
                              <CustomSvg name="profile" />
                            </div>
                            <input
                              name="username"
                              style={{ width: "94%" }}
                              placeholder="Enter your username"
                              className="text-white mx-4 rounded-xl text-base font-quantico bg-transparent outline-none w-full"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.username}
                            />
                          </div>
                          <ErrorMessage
                            name="username"
                            render={(msg) => <CustomErrorMsg errorMsg={msg} />}
                          />
                        </div>

                        {/* Email */}
                        <div>
                          <div className="flex items-center justify-between rounded-2xl bg-white/10  p-2">
                            <div className="w-[3%]">
                              <CustomSvg name="mail" />
                            </div>
                            <input
                              type="email"
                              name="email"
                              placeholder="Enter your email address"
                              className="text-white mx-4 rounded-xl text-base font-quantico bg-transparent outline-none w-full"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.email}
                            />
                          </div>
                          <ErrorMessage
                            name="email"
                            render={(msg) => <CustomErrorMsg errorMsg={msg} />}
                          />
                        </div>
                        {/* Phone */}
                        <div>
                          <div className="flex items-center justify-between rounded-2xl bg-white/10 p-2">
                            <div className="w-[3%]">
                              <FaPhone size={16} color="#fff" />
                            </div>
                            <input
                              type="text"
                              name="phoneNumber"
                              placeholder="Enter your phone number"
                              className="text-white mx-4 rounded-xl text-base font-quantico bg-transparent outline-none w-full"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.phoneNumber}
                            />
                          </div>
                          <ErrorMessage
                            name="phoneNumber"
                            render={(msg) => <CustomErrorMsg errorMsg={msg} />}
                          />
                        </div>

                        {/* Referral Code (optional) */}
                        <div>
                          <div className="flex items-center justify-between rounded-2xl bg-white/10 p-2">
                            <div className="w-[3%]">
                              <FaGift size={16} color="#fff" />
                            </div>
                            <input
                              name="referralCode"
                              style={{ width: "94%" }}
                              placeholder="Referral code (optional)"
                              className="text-white mx-4 rounded-xl text-base font-quantico bg-transparent outline-none w-full"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.referralCode}
                            />
                          </div>
                        </div>
                        {/* DOB */}
                        <div>
                          <div className="flex items-center justify-between rounded-2xl bg-white/10 p-2 cursor-pointer">
                            <div className="w-[3%]">
                              <CustomSvg name="calendar" />
                            </div>
                            <InputMask
                              mask="9999-99-99"
                              value={values.dob}
                              onChange={handleChange}
                            >
                              {(inputProps) => (
                                <input
                                  {...inputProps}
                                  name="dob"
                                  placeholder="YYYY-MM-DD"
                                  className="text-white mx-4 text-base font-quantico bg-transparent outline-none w-full"
                                />
                              )}
                            </InputMask>
                          </div>
                        </div>
                        {/* Password */}
                        <div>
                          <div className="flex items-center bg-white/10 rounded-2xl gap-3 p-2">
                            <div className="w-[3%]">
                              <CustomSvg name="lock" />
                            </div>
                            <input
                              name="password"
                              type={passwordVisible ? "text" : "password"}
                              placeholder="Enter your password"
                              className="text-white mx-2 rounded-xl text-base font-quantico bg-transparent outline-none w-full"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.password}
                            />
                          <div
                            className="cursor-pointer"
                            onClick={togglePasswordVisibility}
                          >
                            {passwordVisible ? (
                          <FiEye color="#fff" />
                            ) : (
                                    <FiEyeOff color="#fff" />
                            
                            )}
                          </div>
                          </div>
                          <ErrorMessage
                            name="password"
                            render={(msg) => <CustomErrorMsg errorMsg={msg} />}
                          />
                        </div>

                        {/* Confirm Password */}
                        <div>
                          <div className="flex items-center bg-white/10 rounded-2xl gap-3 p-2">
                            <div className="w-[3%]">
                              <CustomSvg name="lock" />
                            </div>
                            <input
                              name="confirmPassword"
                              type={
                                confirmPasswordVisible ? "text" : "password"
                              }
                              placeholder="Confirm your password"
                              className="text-white mx-2 rounded-xl text-base font-quantico bg-transparent outline-none w-full"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.confirmPassword}
                            />
                            <div className="absolute right-6">
                              <div
                            className="cursor-pointer"
                            onClick={togglePasswordVisibility}
                          >
                            {passwordVisible ? (
                          <FiEye color="#fff" />
                            ) : (
                                    <FiEyeOff color="#fff" />
                            
                            )}
                          </div>
                            </div>
                          </div>
                          <ErrorMessage
                            name="confirmPassword"
                            render={(msg) => <CustomErrorMsg errorMsg={msg} />}
                          />
                        </div>
                      </div>
                      {/* Terms */}
                      <div className="flex text-left justify-start mb-5">
                        <div className="flex items-center space-x-2">
                          <div
                            className="cursor-pointer"
                            onClick={toggleTermsAgreement}
                          >
                            {termsAgreed ? (
                              <MdOutlineCheckBox color="#FFF" size={15} />
                            ) : (
                              <MdOutlineCheckBoxOutlineBlank
                                color="#FFF"
                                size={15}
                              />
                            )}
                          </div>
                         <p className="font-light text-sm text-white font-poppins">
  By checking the box you agree to our{" "}
  <button
    type="button"
    className="text-pink-600/70 underline hover:text-pink-400 bg-transparent border-none p-0 m-0 cursor-pointer"
    style={{ background: "none" }}
    onClick={goToTerms}
  >
    Terms
  </button>{" "}
  and{" "}
  <button
    type="button"
    className="text-pink-600/70 underline hover:text-pink-400 bg-transparent border-none p-0 m-0 cursor-pointer"
    style={{ background: "none" }}
    onClick={goToTerms}
  >
    Conditions
  </button>
</p>
                        </div>
                      </div>

                      {/* Submit */}
                      <div className="w-full mb-3">
                        <button
                          onClick={handleSubmit}
                          disabled={!(isValid && dirty) || apiReqs.isLoading}
                          style={{
                            opacity:
                              !(isValid && dirty) || apiReqs.isLoading
                                ? 0.5
                                : 1,
                          }}
                          className="w-full bg-pink-600 text-white flex items-center justify-center p-2 rounded"
                        >
                          {apiReqs.isLoading ? (
                            <div className="py-1">
                              <Spinner size="sm" variant="light" />
                            </div>
                          ) : (
                            <>
                              <p className="m-0 text-sm font-medium font-poppins mx-1">
                                Register
                              </p>
                              <div className="mx-2 flex items-center">
                                <CustomSvg name="arrow-right" />
                              </div>
                            </>
                          )}
                        </button>
                      </div>
                    </>
                  )}
                </Formik>

                {/* Go to Login */}
                <div
                  onClick={goToLogin}
                  className="flex items-center justify-center cursor-pointer"
                >
                  <p className="font-light text-sm text-white font-poppins m-0 mx-2">
                    Already have an account?{" "}
                    <span className="text-pink-600/70">Login</span>.
                  </p>
                </div>
              </div>

              {/* Right side carousel */}
              <div className="hidden md:hidden lg:flex justify-center items-center w-full lg:w-6/12">
                <div className="w-full max-w-lg bg-white/10 p-4 rounded">
                  <Carousel controls={false}>{displayCarouselItems}</Carousel>
                </div>
              </div>
            </div>
          </div>
        </ScrollTo>
      )}

      <SuccessModal
        accountType={accountType}
        modalProps={successModal}
        redirectFunc={goToVerifyEmail}
        subTxt={accountType === "celebrity" ? "Your account is under review and waiting for approval by the admin. You will be notified once your account is approved." : "Registration completed, we are redirecting you..."}
   
     />
      {/* Celebrity review popup */}
      {accountType === "celebrity" && successModal.visible && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
          <div className="bg-white rounded-2xl shadow-lg p-8 max-w-sm w-full flex flex-col items-center">
            <h2 className="text-2xl font-bold text-[#56920D] mb-4 text-center">Account Under Review</h2>
            <p className="text-gray-700 text-center mb-6">
              Thank you for registering! Your account is under review and waiting for approval by the admin. You will be notified once your account is approved.
            </p>
            <button
              className="bg-[#56920D] text-white px-6 py-2 rounded-lg font-semibold hover:bg-[#407a0a] transition"
              onClick={hideSuccessModal}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
